/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'pdf': {
    width: 25,
    height: 25,
    viewBox: '0 0 25 25',
    data: '<path pid="0" _fill="#008cff" d="M19.282-.01l5.725 5.736-.592.594H25v17.84c0 .464-.36.84-.806.84H7.806C7.36 25 7 24.624 7 24.16V21h1.612v2.32h14.776V8h-5.582C17.36 8 17 7.624 17 7.16V1.68H8.612V9H7V.84c0-.464.36-.84.806-.84h10.806v.663zm-.67 6.33h4.429l-4.43-4.436z"/><text dominant-baseline="text-before-edge" style="text-transform:uppercase;line-height:5.35445px" _fill="#229bff" font-family="\'OpenSans-Extrabold\',\'OpenSans-Extrabold\'" font-size="2.14" font-style="none" font-weight="400" transform="translate(0 11)"><tspan style="font-kerning:normal">pdf</tspan></text>'
  }
})
